import React, { useEffect, useState } from 'react';
import { BOAPI } from "../service/UsersService";

// כרטיסי "מצב נוכחי" - לא תלויים בטווח התאריכים, תמיד המצב עכשיו ממש.
// המפתחות תואמים בדיוק לעמודות שמחזירה spBODashboard (BO.sql)
const SNAPSHOT_CARDS = [
  // usersTotal = כל המשתמשים הפעילים (גם בעלי עסקים ומנהלים); ownersTotal =
  // משתמשים שהם בעלים של לפחות בית עסק אחד
  { key: 'usersTotal',                label: 'משתמשים רשומים',       emoji: '👥', color: '#1f6feb', bg: '#EEF2FF' },
  { key: 'ownersTotal',               label: 'בעלי עסקים',           emoji: '🧑‍💼', color: '#8B5CF6', bg: '#F5F3FF' },
  { key: 'businessesLive',            label: 'בתי עסק פעילים',       emoji: '🏪', color: '#34D399', bg: '#ECFDF5' },
  { key: 'codesPendingRedemption',    label: 'קודי מימוש ממתינים',   emoji: '⏳', color: '#FB923C', bg: '#FFF7ED' },
  { key: 'businessSubmissionsPending',label: 'הצעות בתי עסק ממתינות', emoji: '📝', color: '#C9A84C', bg: '#FEF9EE' },
];

// כרטיסי "בטווח שנבחר" - תלויים בטווח התאריכים (RANGE_PRESETS למטה, אותה
// מוסכמה בדיוק כמו ActivitiesTab.jsx)
const RANGE_CARDS = [
  { key: 'loginsInRange',            label: 'כניסות לאפליקציה',  emoji: '🔑', color: '#818CF8', bg: '#EEF2FF' },
  { key: 'newUsersInRange',          label: 'הרשמות חדשות',       emoji: '🆕', color: '#34D399', bg: '#ECFDF5' },
  { key: 'codesRequestedInRange',    label: 'קודי מימוש שהונפקו', emoji: '🎟️', color: '#C9A84C', bg: '#FEF9EE' },
  { key: 'redeemedInRange',          label: 'הטבות שמומשו',       emoji: '✅', color: '#34D399', bg: '#ECFDF5' },
  { key: 'salesAmountInRange',       label: 'מחזור מכירות (₪)',   emoji: '💵', color: '#60A5FA', bg: '#EFF6FF' },
  // עסקאות שבוטלו לא נכללות במחזור/בעמלה (ראו spBODashboard)
  { key: 'commissionInRange',        label: 'עמלה לחיוב (₪)',     emoji: '🧾', color: '#8B5CF6', bg: '#F5F3FF' },
  { key: 'cancelledInRange',         label: 'עסקאות שבוטלו',      emoji: '↩️', color: '#d93838', bg: '#FFF1F1' },
];

const RANGE_PRESETS = [
  { key: '24h',   label: '24 שעות אחרונות', hours: 24 },
  { key: '3d',    label: '3 ימים אחרונים',   hours: 24 * 3 },
  { key: 'week',  label: 'שבוע אחרון',       hours: 24 * 7 },
  { key: 'month', label: 'חודש אחרון',       hours: 24 * 30 },
  { key: 'custom',label: 'מותאם אישית' },
];

const toDateTimeLocal = (d) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const toLocalSqlDateTime = (d) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

const DashboardTab = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [rangePreset, setRangePreset] = useState('24h');
  const [customFrom, setCustomFrom] = useState(() => toDateTimeLocal(new Date(Date.now() - 24 * 60 * 60 * 1000)));
  const [customTo, setCustomTo] = useState(() => toDateTimeLocal(new Date()));

  const load = async (range) => {
    setLoading(true);
    setError(null);
    try {
      const res = await BOAPI.fetchDashboard(range);
      if (res?.[0]?.[0]?.code === 0) {
        setData(res[1]?.[0] || null);
      } else {
        setError(res?.[0]?.[0]?.msg || 'שגיאה בטעינת הדשבורד');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (rangePreset === 'custom') return;
    const preset = RANGE_PRESETS.find(p => p.key === rangePreset);
    const toDate = new Date();
    const fromDate = new Date(toDate.getTime() - preset.hours * 60 * 60 * 1000);
    load({ fromDate: toLocalSqlDateTime(fromDate), toDate: toLocalSqlDateTime(toDate) });
  }, [rangePreset]);

  const handleApplyCustomRange = () => {
    if (!customFrom || !customTo) return;
    load({ fromDate: `${customFrom.replace('T', ' ')}:00`, toDate: `${customTo.replace('T', ' ')}:00` });
  };

  if (loading && !data) return <div style={s.center}>טוען דשבורד...</div>;

  return (
    <div style={s.container}>
      <div style={s.headerRow}>
        <h2 style={s.title}>דשבורד</h2>
        <span style={s.todayBadge}>
          📅 {new Date().toLocaleDateString('he-IL', { weekday: 'long', day: 'numeric', month: 'long' })}
        </span>
      </div>

      {error && (
        <div style={s.errorBanner}>
          ❌ {error}
          <button style={s.closeErr} onClick={() => setError(null)}>✕</button>
        </div>
      )}

      {data && (
        <div style={s.grid}>
          {SNAPSHOT_CARDS.map((card) => (
            <StatCard key={card.key} card={card} value={data[card.key]} />
          ))}
        </div>
      )}

      <h3 style={s.sectionTitle}>בטווח שנבחר</h3>

      <div style={s.rangeRow}>
        {RANGE_PRESETS.map(opt => (
          <button
            key={opt.key}
            style={{ ...s.rangeBtn, ...(rangePreset === opt.key ? s.rangeBtnActive : {}) }}
            onClick={() => setRangePreset(opt.key)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {rangePreset === 'custom' && (
        <div style={s.customRangeRow}>
          <label style={s.customLabel}>
            מתאריך
            <input type="datetime-local" style={s.customInput} value={customFrom} onChange={(e) => setCustomFrom(e.target.value)} />
          </label>
          <label style={s.customLabel}>
            עד תאריך
            <input type="datetime-local" style={s.customInput} value={customTo} onChange={(e) => setCustomTo(e.target.value)} />
          </label>
          <button style={s.applyBtn} onClick={handleApplyCustomRange}>החל</button>
        </div>
      )}

      {loading ? (
        <div style={s.center}>טוען...</div>
      ) : data && (
        <div style={s.grid}>
          {RANGE_CARDS.map((card) => (
            <StatCard key={card.key} card={card} value={data[card.key]} />
          ))}
        </div>
      )}
    </div>
  );
};

function StatCard({ card, value }) {
  return (
    <div style={s.card}>
      <div style={{ ...s.cardIcon, background: card.bg }}>
        <span style={{ fontSize: 22 }}>{card.emoji}</span>
      </div>
      <div style={s.cardBody}>
        <div style={{ ...s.cardValue, color: card.color }}>{value ?? 0}</div>
        <div style={s.cardLabel}>{card.label}</div>
      </div>
    </div>
  );
}

const s = {
  container:  { padding: 20, direction: 'rtl', fontFamily: 'Arial, sans-serif' },
  center:     { padding: 40, textAlign: 'center', color: '#999' },
  headerRow:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 20 },
  title:      { margin: 0, color: '#1a1f36', fontSize: 24, fontWeight: 'bold' },
  todayBadge: { display: 'inline-block', background: '#e8f5e9', color: '#2e7d32', borderRadius: 20, padding: '5px 16px', fontSize: 13, fontWeight: 700 },
  errorBanner:{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#ffebee', color: '#c62828', padding: 14, borderRadius: 6, marginBottom: 16 },
  closeErr:   { background: 'transparent', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: 18 },

  sectionTitle: { fontSize: 15, fontWeight: 700, color: '#1a1f36', margin: '28px 0 12px' },

  rangeRow:   { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 },
  rangeBtn:   { padding: '7px 14px', borderRadius: 20, border: '1.5px solid #e3e8ee', background: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#697386' },
  rangeBtnActive: { background: '#1a1f36', borderColor: '#1a1f36', color: '#fff' },

  customRangeRow: { display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 20, padding: 14, background: '#f8fafc', borderRadius: 8, border: '1px dashed #e3e8ee' },
  customLabel:    { display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12, fontWeight: 600, color: '#4f566b' },
  customInput:    { padding: '6px 10px', borderRadius: 6, border: '1.5px solid #e3e8ee', fontSize: 13 },
  applyBtn:       { padding: '8px 18px', borderRadius: 8, border: 'none', background: '#1f6feb', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 700, height: 34 },

  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 },
  card: {
    display: 'flex', alignItems: 'center', gap: 14,
    background: '#fff', borderRadius: 16, border: '1px solid #e3e8ee',
    boxShadow: '0 4px 16px rgba(0,0,0,0.04)', padding: '18px 20px',
  },
  cardIcon: { width: 48, height: 48, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  cardBody: { display: 'flex', flexDirection: 'column', gap: 2 },
  cardValue: { fontSize: 26, fontWeight: 800, lineHeight: 1.1 },
  cardLabel: { fontSize: 13, fontWeight: 600, color: '#4f566b' },
};

export default DashboardTab;
